
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from "@/components/ui/toaster";
import { ThemeProvider } from '@/contexts/ThemeContext';
import { BoardContextProvider } from '@/contexts/BoardContext';
import ProtectedRoute from '@/components/ProtectedRoute';
import Index from '@/pages/Index';
import Dashboard from '@/pages/Dashboard';
import Auth from '@/pages/Auth';
import Calendar from '@/pages/Calendar';
import Notes from '@/pages/Notes';
import NotFound from '@/pages/NotFound';
import { AcceptInvitation } from '@/pages/AcceptInvitation';
import { BoardSettings } from '@/components/BoardSettings';
import './App.css';
import { supabase } from "@/integrations/supabase/client";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
    /*const originalFrom = supabase.from.bind(supabase);

    function getCallerInfo() {
        const err = new Error();
        const stack = err.stack?.split('\n') ?? [];

        for (const line of stack.slice(3)) {
            // Better pattern matching for source maps and clearer traces
            const match = line.match(/at\s+(.*?)\s+\((.*?):(\d+):(\d+)\)/) || line.match(/at\s+(.*?):(\d+):(\d+)/);

            if (match) {
                const [, funcOrFile, file = match[1], lineNum = match[2], colNum = match[3]] = match;
                if (file.includes('node_modules')) continue; // skip framework/internal

                return `${funcOrFile} @ ${file}:${lineNum}:${colNum}`;
            }
        }

        return 'unknown source';
    }

    supabase.from = (...args) => {
        const caller = getCallerInfo();
        console.groupCollapsed(`📡 supabase.from called → ${args[0]}`);
        console.log('Caller:', caller);
        console.trace('Full Trace');
        console.groupEnd();
        return originalFrom(...args);
    };

    */
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider>
        <BoardContextProvider>
          <Router>
            <div className="min-h-screen bg-background text-foreground">
              <Routes>
                <Route path="/auth" element={<Auth />} />
                <Route path="/accept-invitation" element={<AcceptInvitation />} />
                <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                <Route path="/" element={<ProtectedRoute><Index /></ProtectedRoute>} />
                <Route path="/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
                <Route path="/notes" element={<ProtectedRoute><Notes /></ProtectedRoute>} />
                <Route path="/board-settings" element={<ProtectedRoute><BoardSettings /></ProtectedRoute>} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
            <Toaster />
          </Router>
        </BoardContextProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
